import { Observer } from 'mobx-react';
import React from 'react';
import SignUpCoverImage from '../assets/sign-up-cover.png';
import { ConciergeRightPaneImage, ConciergeRightPaneText, ConciergeRightPaneTextWrapper, ConciergeRightPaneWrapper } from './ConciergeRightPane.styles';

export const ConciergeRightPane = () => {
  return (<Observer>{() => (
    <ConciergeRightPaneWrapper>
      <ConciergeRightPaneTextWrapper>
        <VyzerTextLogo />
        <ConciergeRightPaneText>Where Your Wealth Lives,<br />Learns, and Works</ConciergeRightPaneText>
      </ConciergeRightPaneTextWrapper>
      <ConciergeRightPaneImage src={SignUpCoverImage} alt='sign-up-cover' />
    </ConciergeRightPaneWrapper>
  )}</Observer>)
}

const VyzerTextLogo = () => {
  return (
    <svg width="64" height="24" viewBox="0 0 64 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.969062 5.69141H3.70948L7.59629 14.6397L11.4831 5.69141H14.2235L8.51885 18.8343H6.6732L0.968506 5.69141H0.969062Z" fill="white" />
      <path d="M36.0274 8.06859H29.2169V5.69141H40.7468L33.4503 16.4571H40.2625V18.8337H28.7537L36.028 8.06804L36.0274 8.06859Z" fill="white" />
      <path d="M63.0272 5.69141H57.8323H55.5679H55.1758V18.8343H57.8323V8.06859H61.993L63.0272 5.69141Z" fill="white" />
      <path d="M17.7921 23.9919H20.6098L28.5744 5.69141H25.7779L22.0033 14.3604L17.8921 5.69141H15.04L20.6609 17.464L17.7921 23.9919Z" fill="white" />
      <path d="M50.924 14.4602L50.8884 14.5369C50.2186 15.9726 48.9944 16.7313 47.3487 16.7313C45.0026 16.7313 43.5413 14.8984 43.2486 13.0128H53.7877L53.7888 12.7984C53.8005 10.6273 53.0612 8.68166 51.7065 7.31977C50.4941 6.10063 48.9033 5.42969 47.2265 5.42969C43.6213 5.42969 40.6887 8.49393 40.6887 12.2602C40.6887 16.0265 43.6141 19.0424 47.3487 19.0424C49.9814 19.0424 52.0276 17.8183 53.099 15.6466L50.924 14.4608V14.4602ZM47.2271 7.74022C48.9261 7.74022 50.4413 8.95492 50.9945 10.7267H43.4119C43.9035 9.20153 45.3176 7.74022 47.2271 7.74022Z" fill="white" />
    </svg>
  )
}